module.exports = __webpack_public_path__ + "img/RedBullPattern.37a0ca12.svg";